export default __webpack_public_path__ + "static/AnythingScript1-0W8Er-5ffee3ce7262b287b45a981fc2cefb35.ttf";